import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import {
  Button,
  Breadcrumb,
  Modal,
  Col,
  Form,
  FormControl,
  FormGroup,
  OverlayTrigger,
  Tooltip,
}from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder } from 'react-bootstrap-table'
import Collapsible from './collapsible'
import StatesDropdown from './statesdropdown'
import Dropdown from './dropdown'
import Validators from '../utils/validators'

@observer(['activities', 'partners', 'globals'])
export default class Partners extends Component {

  constructor(props) {
    super(props)

    if (this.props.partners.data.length == 0) {
      this.props.partners.loadAllPartnerCompanies()
    }
    this.props.partners.loadAllOrganizationPartners(localStorage.getItem('userOrganizationId'))
    this.props.partners.loadPartnerCompanies()
    

    this.state = {
      showNewPartnerModal: false,
      partnerCode: '',
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      state: 1,
      zipCode: '',
      email: '',
      phone: ''
    }
  }

  openNewPartnerModal() {
    this.setState({
      showNewPartnerModal: true
    })
  }

  closeNewPartnerModal() {
    this.setState({
      showNewPartnerModal: false
    })
  }

  validateForm() {
    if (this.getNewPartnerCodeValidationState() == 'error') {
      return false
    }

    if (this.getNewPartnerFirstNameValidationState() == 'error') {
      return false
    }

    if (this.getNewPartnerLastNameValidationState() == 'error') {
      return false
    }

    /*
    if (this.getNewPartnerAddressValidationState() == 'error') {
      return false
    }

    if (this.getNewPartnerCityValidationState() == 'error') {
      return false
    }

    if (this.getNewPartnerZipCodeValidationState() == 'error') {
      return false
    }
    */

    if (this.getNewPartnerEmailValidationState() == 'error') {
      return false
    }

    /*
    if (this.getNewPartnerPhoneValidationState() == 'error') {
      return false
    }
    */

    return true
  }

  getNewPartnerCodeValidationState() {
    if (Validators.validString(this.state.partnerCode)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerFirstNameValidationState() {
    if (Validators.validString(this.state.firstName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerLastNameValidationState() {
    if (Validators.validString(this.state.lastName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerAddressValidationState() {
    if (Validators.validString(this.state.address)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerCityValidationState() {
    if (Validators.validString(this.state.city)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerZipCodeValidationState() {
    if (Validators.validString(this.state.zipCode)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerEmailValidationState() {
    if (Validators.validEmail(this.state.email)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewPartnerPhoneValidationState() {
    if (Validators.validString(this.state.phone)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  newPartnerCodeChanged(e) {
    this.setState({
      partnerCode: e.target.value
    })
  }

  newPartnerFirstNameChanged(e) {
    this.setState({
      firstName: e.target.value
    })
  }

  newPartnerLastNameChanged(e) {
    this.setState({
      lastName: e.target.value
    })
  }

  newPartnerAddressChanged(e) {
    this.setState({
      address: e.target.value
    })
  }

  newPartnerCityChanged(e) {
    this.setState({
      city: e.target.value
    })
  }

  newPartnerZipCodeChanged(e) {
    this.setState({
      zipCode: e.target.value
    })
  }

  newPartnerEmailChanged(e) {
    this.setState({
      email: e.target.value
    })
  }

  newPartnerPhoneChanged(e) {
    this.setState({
      phone: e.target.value
    })
  }

  onStateChanged(e) {
    this.setState({
      state: e.target.value
    })
  }

  formatActions(cell, row) {
    return (
      <div>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'partnerId-' + cell}>View Partner</Tooltip> }><Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { browserHistory.push('/partner/' + row.id) } }><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button></OverlayTrigger>
        { /* <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { this.openEditPartnerModal(cell) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button> */ }
        { /* <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deletePartner(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button> */ }
      </div>
    )
  }

  newPartner(e) {
    const pct = document.getElementById('partnerCompany_Type').value.split(',')
    let data = {
      organizationId: this.props.globals.loggedInUser.organizationId,
      partnerCompanyId: pct[0],
      partnerTypeId: pct[1],
      partnerCode: this.state.partnerCode,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      city: this.state.city,
      address: this.state.address,
      state: this.state.state,
      zipCode: this.state.zipCode,
      email: this.state.email,
      phone: this.state.phone
    }

    if (this.validateForm()) {
      this.props.partners.newPartner(data, (data) => {
        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 5, data.addPartner.id, 3, localStorage.getItem('userOrganizationId'))
        browserHistory.push('partner/' + data.addPartner.id)
      })
      this.closeNewPartnerModal()
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  deletePartner(id) {
    if (confirm('Are you sure you want to delete this partner?')) {
      this.props.partners.deletePartner(id, this.props.globals.loggedInUser.organizationId)
    }
  }

  formatCompany(cell, row) {
    let company = 'loading...'

    if (this.props.partners.partnerCompanies.length > 0) {
      for( let i = 0; i < this.props.partners.partnerCompanies.length; i++ ) {
        if (cell == this.props.partners.partnerCompanies[i].id) {
          company = this.props.partners.partnerCompanies[i].name
          return company
        }
      }
    }

    return company
  }

  render() {

    const options = {
      onAddRow: this.newPartner.bind(this),
      defaultSortName: 'fullName',  // default sort column name
      defaultSortOrder: 'asc'  // default sort order
    }

    const partnerTypeDropdown = this.props.partners.all ?
    (
      <FormControl componentClass="select" id="partnerCompany_Type">
        {
          this.props.partners.all.map((comp) => {
            return (
              <optgroup label={ comp.name }>
              {
                comp.partnerTypes ? comp.partnerTypes.map((pt) => {
                  return (<option value={ comp.id + ',' + pt.id }>{ pt.name }</option>)
                }) : (<option>LOADING...</option>)
              }
              </optgroup>
            )
          })
        }
      </FormControl>
    ) : (
      <div>Loading...</div>
    )

    let partnersTable = (<a><img src="images/loading.gif" /></a>)

    if (this.props.partners.data.length > 0) {
      partnersTable = (
        <div>
          <Button bsStyle="info" onClick={this.openNewPartnerModal.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
          <BootstrapTable
              data={ this.props.partners.data }
              striped={ true }
              hover={ true }
              pagination={ true }
              search={ true }
              options={ options }
              bordered={ true } >
            <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="fullName" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="partnerCompanyId" dataSort={ true } dataFormat={ this.formatCompany.bind(this) } editable={{ validator: Validators.validString }}>Company</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="partnerCode" dataSort={ true } editable={{ validator: Validators.validString }}>Partner Code</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="email" dataSort={ true } editable={{ validator: Validators.validString }}>Email</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="phone" dataSort={ true } editable={{ validator: Validators.validString }}>Phone</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="fullAddress" dataSort={ true } editable={{ validator: Validators.validString }}>Address</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
          </BootstrapTable>
        </div>
      )
    }

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            { /*
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Partners</Breadcrumb.Item>
            </Breadcrumb>
            </div>
            */ }
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Partners" content={ partnersTable } />
        </div>
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showNewPartnerModal } onHide={ this.closeNewPartnerModal.bind(this) } bsSize="medium">
          <Modal.Header closeButton>
            <Modal.Title>New Partner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newPartnerForm">
              <FormGroup>
                <Col sm={ 6 }>{ partnerTypeDropdown }</Col>
                <Col sm={ 6 }>
                  <FormGroup validationState={ this.getNewPartnerCodeValidationState() }>
                    <FormControl type="text" placeholder="Partner Code" id="partnerCode" onChange={ this.newPartnerCodeChanged.bind(this) } />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 6 }>
                  <FormGroup validationState={ this.getNewPartnerFirstNameValidationState() }>
                    <FormControl type="text" placeholder="Partner First Name" id="firstName" onChange={ this.newPartnerFirstNameChanged.bind(this) } />
                  </FormGroup>
                </Col>
                <Col sm={ 6 }>
                  <FormGroup validationState={ this.getNewPartnerLastNameValidationState() }>
                    <FormControl type="text" placeholder="Partner Last Name" id="lastName" onChange={ this.newPartnerLastNameChanged.bind(this) } />
                  </FormGroup>
                </Col>
              </FormGroup>
              { /*
              <FormGroup validationState={ this.getNewPartnerAddressValidationState() }>
                <Col sm={ 12 }><FormControl placeholder="Address" id="address" onChange={ this.newPartnerAddressChanged.bind(this) } /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 4 }>
                  <FormGroup validationState={ this.getNewPartnerCityValidationState() }>
                    <FormControl placeholder="City" id="city" onChange={ this.newPartnerCityChanged.bind(this) } />
                  </FormGroup>
                </Col>
              */ }
              <FormGroup>
                <Col sm={ 12 }><FormControl placeholder="Address" id="address" onChange={ this.newPartnerAddressChanged.bind(this) } /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 4 }>
                  <FormGroup>
                    <FormControl placeholder="City" id="city" onChange={ this.newPartnerCityChanged.bind(this) } />
                  </FormGroup>
                </Col>
                <Col sm={ 4 }>
                  <FormGroup>
                    <StatesDropdown id="state" onChange={ this.onStateChanged.bind(this) } />
                  </FormGroup>
                </Col>
                <Col sm={ 4 }>
                  { /* <FormGroup validationState={ this.getNewPartnerZipCodeValidationState() }> */ }
                  <FormGroup>
                    <FormControl placeholder="Zip Code" id="zipCode" onChange={ this.newPartnerZipCodeChanged.bind(this) } />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 6 }>
                  <FormGroup validationState={ this.getNewPartnerEmailValidationState() }>
                    <FormControl placeholder="Email" id="email" onChange={ this.newPartnerEmailChanged.bind(this) } />
                  </FormGroup>
                </Col>
                <Col sm={ 6 }>
                  { /*
                  <FormGroup validationState={ this.getNewPartnerPhoneValidationState() }>
                    <FormControl placeholder="Phone" id="phone" onChange={ this.newPartnerPhoneChanged.bind(this) } />
                  </FormGroup>
                  */ }
                  <FormGroup>
                    <FormControl placeholder="Phone" id="phone" onChange={ this.newPartnerPhoneChanged.bind(this) } />
                  </FormGroup>
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeNewPartnerModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.newPartner.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partners.js